import { render, staticRenderFns } from "./AccountsView.vue?vue&type=template&id=36642aef&scoped=true"
import script from "./AccountsView.vue?vue&type=script&lang=js"
export * from "./AccountsView.vue?vue&type=script&lang=js"
import style0 from "./AccountsView.vue?vue&type=style&index=0&id=36642aef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36642aef",
  null
  
)

export default component.exports